import React from 'react';
import Link from '../link';

const ContactUsContainer: React.FC = () => (
  <section>
    <div className="contact-us">
      <p>
        If you have questions regarding this site, or items purchased using this
        site, please contact us:
      </p>
      <div className="group">
        <h3>For VIDA Subscription and download questions:</h3>
        <p>
          All support for VIDA is managed through the{' '}
          <Link href="/knowledgebase">
            <a>Support</a>
          </Link>{' '}
          section on this site. All VIDA subscription and Download information
          can be found{' '}
          <Link href="/vida">
            <a>here</a>
          </Link>
          . Please refer to these sections for assistance with VIDA
          subscriptions and software downloads.
        </p>
        <p>
          For <strong>VIDA Subscriptions</strong>{' '}
          <Link href="/vida/purchase#purchase-vida-subscription">
            <a>click here</a>
          </Link>
          .
        </p>
        <p>
          Note: There is no telephone support for VIDA Subscription or Software
          related Inquires.
        </p>
      </div>
      <div className="group">
        <div>
          <h3>For Literature and Fulfillment questions:</h3>
          <p className="space-between">
            <span>Note:</span>
            <span>
              The Literature and Fulfillment Center cannot answer any VIDA
              Subscription or Software related Inquires.
            </span>
          </p>
          <p className="space-between">
            <span>Email:</span>
            <span>
              <Link href="mailto:vtihelp@volvotechinfo.com">
                <React.Fragment>vtihelp@volvotechinfo.com</React.Fragment>
              </Link>
            </span>
          </p>
          <p className="space-between">
            <span>Phone:</span>
            <span>
              1-800-258-6586 (1-800-25VOLVO)
              <br />
              Monday through Friday, 8:00 a.m. 4:30 p.m. Central Time
            </span>
          </p>
          <p className="space-between">
            <span>Mail:</span>
            <span>
              <strong>Volvo Car USA, LLC.</strong>
              <br />
              C/O VolvoTechInfo.com
              <br />
              2855 S Calhoun Rd
              <br />
              New Berlin, WI 53151
            </span>
          </p>
        </div>
      </div>
    </div>
    {/* language=CSS */}
    <style jsx>{`
      .contact-us {
        font-family: 'Volvo Novum', sans-serif;
        width: 100%;
      }

      h2,
      h3,
      strong {
        font-weight: 500;
      }

      a {
        color: #333;
      }

      a:hover {
        color: #707070;
      }

      .group {
        display: block;
        width: 100%;
      }

      .space-between {
        display: flex;
        justify-content: space-between;
      }

      .space-between > span:first-child {
        flex: 1;
      }

      .space-between > span:last-child {
        flex: 4;
      }
    `}</style>
  </section>
);

export default ContactUsContainer;
